import type { HTMLAttributes, ReactNode } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function Card({ children, className = '', ...rest }: CardProps): JSX.Element {
  return (
    <div
      className={[
        'rounded-lg border border-[rgb(var(--edge-rgb)/0.10)] glass',
        'shadow-sm p-6',
        className,
      ].join(' ')}
      {...rest}
    >
      {children}
    </div>
  );
}

export function CardHeader({ children, className = '', ...rest }: CardProps): JSX.Element {
  return (
    <div className={['mb-4 flex items-start justify-between gap-4', className].join(' ')} {...rest}>
      {children}
    </div>
  );
}

export function CardTitle({ children, className = '' }: { children: ReactNode; className?: string }): JSX.Element {
  return (
    <h2 className={['font-display text-xl text-[var(--color-text)]', className].join(' ')}>
      {children}
    </h2>
  );
}

export function CardDescription({ children, className = '' }: { children: ReactNode; className?: string }): JSX.Element {
  return (
    <p className={['text-sm text-[var(--color-muted)]', className].join(' ')}>{children}</p>
  );
}
